import React, { useEffect, useState } from "react";
import "./Quality_Management.css";
import Quality_Management_Routes from "./quality_Management_routes/Quality_Management_Routes";
import Quality_Management_Sidebar from "./quality_Management_Sidebar/Quality_Management_Sidebar";
import { FixIDS } from "../../../utils/fixIDS";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin } from "../../../features/auth/Slice";

const Quality_Management = () => {
  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(
    FixIDS.Quality_management.List,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GETAuthLogin());
  }, [dispatch]);
  return (
    <section className="Reports_Generation">
      <div className="row me-0 ms-0 p-0">
        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-4 ps-md-0  p-0">
          {haveReadPermission && <Quality_Management_Sidebar />}
        </div>
        <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-8 col-sm-8 p-0">
          <div className="Management_contnet_holder">
            {haveReadPermission && <Quality_Management_Routes />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Quality_Management;
